/* eslint-disable */
import React from 'react';

const BUTTON_DEMO_MODE_INTERVAL = 2000;
const BUTTON_DEMO_MODE_INITIAL_DELAY = 1700;

let buttonDemoMode = false;

let demoMessages = false;
export const getDemoMessages = () => demoMessages;
export const activateChatDemoMode = (messages) => (demoMessages = messages);

export const setButtonDemoMode = (val) => {
	buttonDemoMode = val;
};

export const isButtonDemoMode = () => buttonDemoMode;

export const shouldButtonsBeDemoed = ({ highlightedField }) =>
	['primaryButtonBackgroundColor', 'primaryButtonFontColor'].indexOf(highlightedField) > -1;

export function useButtonDemoMode(setShowModal) {
	const [intervalId, setIntervalId] = React.useState();
	const [timeoutId, setTimeoutId] = React.useState();

	React.useEffect(
		() => {
			clearInterval(intervalId);
			clearTimeout(timeoutId);
			if (buttonDemoMode) {
				const timeout = setTimeout(startButtonDemoInterval, BUTTON_DEMO_MODE_INITIAL_DELAY);
				setTimeoutId(timeout);
			} else {
				setShowModal(false);
			}

			function startButtonDemoInterval() {
				setShowModal(true);
				const int = setInterval(() => setShowModal((val) => !val), BUTTON_DEMO_MODE_INTERVAL);
				setIntervalId(int);
			}

			return () => clearInterval(intervalId);
		},
		[buttonDemoMode]
	);
	return {
		isDemoMode: !!getDemoMessages() && !!getDemoMessages.length,
	};
}
